// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujPuces.js
//  SujPuces
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

// Liste à puces d'un récap
export function SujPuces({ titre, items, color, puce }) {
  if (!items || items.length === 0) return null;
  return (
    <div style={{ marginTop: 10 }}>
      <div style={{ color: THEME.textMuted, fontSize: 10, fontWeight: 700, letterSpacing: 0.6, textTransform: "uppercase", marginBottom: 5 }}>{titre}</div>
      {items.map((t, i) => (
        <div key={i} style={{ color: color || THEME.text, fontSize: 12, lineHeight: 1.5, padding: "1px 0" }}>{puce || "·"} {t}</div>
      ))}
    </div>
  );
}
